/**
 * 公共方法
 */
var util ={   
    /**
     * 在新页面打开
     * @param {*} $this
     * @param {*} routeName
     * @param {*} param 参数对象，对象格式
     */
    OpenNewPage:function($this,routePath,param){
        let routeData=$this.$router.resolve({
            path:routePath,
            query:param
        });
        window.open(routeData.href,'_blank');
    },
    /**
     * 写入sessionStorage
     */
    setSessionStorage:function(key,objData){
        if(typeof objData=='string'){
            sessionStorage.setItem(key,objData);
        }
        else{
            sessionStorage.setItem(key,JSON.stringify(objData));
        }
        
    },
    /**
     * 读取sessionStorage
     */
    getSessionStorage: function(key,isObj){
        var data= sessionStorage.getItem(key);
        if(isObj){
            return JSON.parse(data);
        }
        return data;
    },
     /**
     * 移除sessionStorage
     */
    removeSessionStorage: function(key){
        sessionStorage.removeItem(key);
    }
    ,
    timestampToTime : function(row, column) {
          var date = row[column.property];
          if (date == undefined) {
             return "";
          }
          return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    isSuccess : function(data,callback) {
        if (data && data.data) {   
            var json = data.data;
            if (json.status == 'SUCCESS') {
                _this.$message({message: '执行成功',type: "success"});
                callback(json);
            }
            else if (json.message) {
                _this.$message({message: json.message,type: "error"});
            }
        }
        else{
            _this.$message({message: '执行异常，请重试',type: "error"});
        }
    },
    //localStorage操作
	storage : {
		// 增加一个本地存储
		setStorage : function(name, data, day){
			var expdate = new Date().getTime();  
            var outms= (day ? day*24*60*60*1000 : 1*24*60*60*1000);
//          var outms= 10*1000;  //测试 时间 10秒
           	data['startTime'] = expdate;
        	data['outTime'] = expdate + outms;
            
            var odj = JSON.stringify(data)
			window.localStorage.setItem(name, odj)
		},
		
		// 获取本地存储的内容
		getStorage : function(name){
			
			var value = window.localStorage.getItem(name);
			
		    if (value) {
		        value = JSON.parse(value);
		        if(new Date().getTime() - value.outTime > 0){
		        	
		        	window.localStorage.removeItem(name);
		        	return null;
		        }else {
		        	return value;
		        }
		    }else {
		    	return value;
		    }
		},
		
		// 删除本地存储
		deleteStorage : function(name){
			
        	window.localStorage.removeItem(name);
		}
	},
	//去左右空格;
	trim: function (s){
		if(Array.prototype.toString.call(s)=='[object String]'){
			return s.replace(/(^\s*)|(\s*$)/g, "");
		}else{
			return s;
		}
	},
		/**
		 * post请求参数初始化
		 */
    setParam: function(_param){
			var params = [];
    	_param = _param || {};
    	_param['token'] = this.getSessionStorage('token') || '';
			for(var key in _param){
				params.push(key + '=' + encodeURIComponent( this.trim(_param[key]) ));
			}
			return params.join('&');
    },
    /**
     * post formData 提交文件  参数格式化
     */
    fromdataSetParam: function(data){
    	data['token'] = this.getSessionStorage('token') || '';
			let formData = new FormData();//通过form数据格式来传
			for(var key in data){
				formData.append(key, data[key])
			}
			return formData
    },
    
    /**
     * 验证权限
     */
    checkPower: function(key){
    	var state = false;
    	var powers = this.getSessionStorage('power', true);
    	for(var j = 0; j < powers.length; j++){
    		if(key == powers[j]){
    			state = true
    			break;
    		}
		}
    	return state
    },
    /**
     * 转为标准时间
     */
    fromString: function(date){
		var datepart = /[0-9]{2,4}-[0-9]{1,2}-[0-9]{1,2}/.exec(date);
		var timepart = /[0-9]{1,2}:[0-9]{1,2}:[0-9]{1,2}/.exec(date);
		var datearray, year, month, day;
		var timearray, hour, minute, second;
		if (datepart.length){
			datearray = datepart[0].split('-');
			year = parseInt(datearray[0], 10);
			month = parseInt(datearray[1], 10);
			day = parseInt(datearray[2], 10);
		}
		if (timepart && timepart.length){
			timearray = timepart[0].split(':');
			hour = parseInt(timearray[0], 10);
			minute = parseInt(timearray[1], 10);
			second = parseInt(timearray[2], 10);
		}
		return timepart && timepart.length ? new Date(year,month,day,hour,minute,second ) : new Date(year,month,day);
	},
    
    /**
     * 时间戳转年月日
     */
    timeStamp: function(date, template){
    	date = new Date(date);
		var year = date.getFullYear();
		var month = date.getMonth() + 1;
		var day = date.getDate();
		var hour = date.getHours() ;
		var minute = date.getMinutes();
		var second = date.getSeconds();
		
		template = template.replace(/yyyy/g, year);
		template = template.replace(/MM/g, (month > 9 ? month : '0' + month) );
		template = template.replace(/dd/g, (day > 9 ? day : '0' + day) );
		template = template.replace(/HH/g, (hour > 9 ? hour : '0' + hour) );
		template = template.replace(/mm/g, (minute > 9 ? minute : '0' + minute) );
		template = template.replace(/ss/g, (second > 9 ? second : '0' + second) );
		
		return template;
	},
	
	
    
    /**
     * 初始化校验 上传图片的格式与尺寸是否正确   file： 需要校验的图片流， width： 图片规定宽度， height： 图片规定高度, _this: 调用方法的当前this
     */
    checkImg: function(file, width, height, _this,callback){
//  	let _this = this;
       	let state = false;
		let img = new Image();
		img.src = file.url;
		img.onload = function() {
			let imgsize = file.size / 1024 / 1024 < 0.5;
			if (file.raw.type.indexOf('image')<0) {
			    _this.$alert('只能上传jpg或png图片！', '图片格式错误',  {confirmButtonText: '确定'})
				callback(false)
			}
			if(!imgsize){
				_this.$alert('图片最大不能超过500kb！', '图片大小错误',  {confirmButtonText: '确定'})
				callback(false)
			}
			state = img.width == width && img.height == height;
			if(!state){
				_this.$alert('图片尺寸必须为'+width+'*'+height+'！', '图片尺寸错误',  {confirmButtonText: '确定'})
				callback(false)
			}
			callback(imgsize && state)
		}
	},
	checkImgB: function(file, width, height, _this,callback){
		//  	let _this = this;
				   let state = false;
				let img = new Image();
				img.src = file.url;
				img.onload = function() {
					let imgsize = file.size / 1024 / 1024 < 0.5;
					if (file.raw.type.indexOf('image')<0) {
						_this.$alert('只能上传jpg或png图片！', '图片格式错误',  {confirmButtonText: '确定'})
						callback(false)
					}
					if(!imgsize){
						_this.$alert('图片最大不能超过500kb！', '图片大小错误',  {confirmButtonText: '确定'})
						callback(false)
					}
					state = img.width == width && img.height == height;
					if(!state){
						_this.$alert('图片尺寸必须为'+width+'*'+height+'！', '图片尺寸错误',  {confirmButtonText: '确定'})
						callback(false)
					}
					callback(imgsize && state)
				}
			},
		checkImgC: function(file,  _this,callback){
			//  	let _this = this;
				let state = false;
			let img = new Image();
			img.src = file.url;
			img.onload = function() {
				let imgsize = file.size / 1024 / 1024 < 0.5;
				if (file.raw.type.indexOf('image')<0) {
					_this.$alert('只能上传jpg或png图片！', '图片格式错误',  {confirmButtonText: '确定'})
					callback(false)
				}
				if(!imgsize){
					_this.$alert('图片最大不能超过500kb！', '图片大小错误',  {confirmButtonText: '确定'})
					callback(false)
				}
				// state = img.width == width && img.height == height;
				state = img.width ==  img.height;
				if(!state){
					_this.$alert('图片尺寸必须为'+'1:1'+'！', '图片尺寸错误',  {confirmButtonText: '确定'})
					callback(false)
				}
				callback(imgsize && state)
			}
		},
		checkImgD: function(file,  _this,callback){
			//  	let _this = this;
				let state = false;
			let img = new Image();
			img.src = file.url;
			img.onload = function() {
				let imgsize = file.size / 1024 / 1024 < 0.5;
				if (file.raw.type.indexOf('image')<0) {
					_this.$alert('只能上传jpg或png图片！', '图片格式错误',  {confirmButtonText: '确定'})
					callback(false)
				}
				if(!imgsize){
					_this.$alert('图片最大不能超过500kb！', '图片大小错误',  {confirmButtonText: '确定'})
					callback(false)
				}
				callback(imgsize )
			}
		},
		checkImg169: function(file,  _this,callback){
			//  	let _this = this;
				let state = false;
			let img = new Image();
			img.src = file.url;
			img.onload = function() {
				let imgsize = file.size / 1024 / 1024 < 0.5;
				if (file.raw.type.indexOf('image')<0) {
					_this.$alert('只能上传jpg或png图片！', '图片格式错误',  {confirmButtonText: '确定'})
					callback(false)
				}
			    else if(!imgsize){
					_this.$alert('图片最大不能超过500kb！', '图片大小错误',  {confirmButtonText: '确定'})
					callback(false)
				}
				else if(img.width/img.height != 16/9){
					_this.$alert('图片尺寸必须为16:9！', '图片尺寸错误',  {confirmButtonText: '确定'})
					callback(false)
				}else{
					callback(imgsize )
				}
				
			}
		},
}


export default util;


// WEBPACK FOOTER //
// ./src/common/util.js